<template>
    <div class="serviceheader-style">
        <h3>服务优势</h3>
  
   
     
    </div>
  </template>
  
  <script setup></script>
  
  <style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    // background-color: skyblue;
  }
  @media screen and (min-width: 769px) and (max-width: 1200px) {
    // background-color: pink;
  }
  @media screen and (min-width: 1201px) and (max-width: 2600px) {
    // background-color: yellow;
    .serviceheader-style {
      width: 1200px;
      margin: 0 auto;
      padding-top: 198px;
      // margin-left: 120px;
     h3{
        color: var(--web-color-text-white, #FFF);
text-align: center;
font-family: PingFang SC;
font-size: 48px;
font-style: normal;
font-weight: 600;
line-height: normal;
     }
   
    }
  }
  </style>
  